import React from 'react'
import NewAllocationItemInput from '../NewAllocationItemInput/NewAllocationItemInput';
import { OnSchedUtils } from '../../../../../../utils';


const NewAllocationItem = ({input, element}) => {
  const classList = 'onsched-border-border-color onsched-dark-color onsched-primary-border-color-hover onsched-primary-border-color-active onsched-primary-border-color-focus FormInput'

  return (
    <div className={'FormInput ' + classList}>
      <label>{OnSchedUtils.Internationalize(element, `setup_resourceSetup_form_allocations_${input.label}_label`) }</label>
      <NewAllocationItemInput input={input} />
    </div>
  )
}

export default NewAllocationItem